// BDSJEA-406: el alta de un productor con un CUIT ya registrado responde 409
// con el contrato de error del proyecto:
//   { status: 409, code: "CONFLICT", codigo: "PRODUCTOR_CUIT_EXISTENTE",
//     idProductor: <id del existente>, message: "Ya existe un productor ..." }
// La decision se toma por el codigo estable, nunca por el texto del mensaje.

export const CODIGO_PRODUCTOR_CUIT_EXISTENTE = "PRODUCTOR_CUIT_EXISTENTE"

/**
 * Devuelve el id del productor existente si `error` es la respuesta de "CUIT
 * ya registrado", o `null` si es cualquier otro error.
 *
 * @param {*} error error de axios
 * @returns {(number|string|null)}
 */
export function idProductorExistente(error) {
  const respuesta = error?.response
  const data = respuesta?.data
  if (respuesta?.status !== 409 || !data) return null
  if (data.codigo !== CODIGO_PRODUCTOR_CUIT_EXISTENTE) return null
  const id = data.idProductor
  const valido =
    (typeof id === "number" && Number.isFinite(id) && id > 0) ||
    (typeof id === "string" && /^[0-9]+$/.test(id))
  return valido ? id : null
}
